import clientsData from '../../data/clients.json';

export default function Clients() {
  const modules = import.meta.glob('/src/assets/images/clients/*.{png,jpg,jpeg,svg,webp,avif}', { eager: true });
  const logos = Object.entries(modules).map(([path, mod]: any) => {
    const file = path.split('/').pop() || '';
    const name = file.replace(/\.[^.]+$/, '').replace(/-/g, ' ');
    return { name, url: mod.default as string };
  });

  const fallback = [
    { name: 'Soprole' },
    { name: 'Nestlé' },
    { name: 'CCU' },
    { name: 'BIMBO' },
    { name: "L'ORÉAL" },
    { name: 'PepsiCo' },
    { name: 'Pin Pan' },
    { name: 'C&S Market' },
    { name: 'Ownel' },
  ];

  const present = new Set(logos.map((l) => l.name.toLowerCase()));
  const baseNames: string[] = clientsData?.clients || [];
  const mergedFallback = [...fallback, ...baseNames.filter(n => !fallback.find(f => f.name.toLowerCase() === n.toLowerCase())).map(n => ({ name: n }))];
  const items = [...logos, ...mergedFallback.filter((f) => !present.has(f.name.toLowerCase()))];

  return (
    <section id="clientes" className="py-20 bg-[#0f0f23]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Nuestros <span className="text-[#9EFF00]">Clientes</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 items-center">
          {items.map((item) => (
            <div key={item.name} className="flex items-center justify-center bg-[#1a1a2e] rounded-xl border border-gray-800 p-6 h-24">
              {'url' in item ? (
                <img src={(item as any).url} alt={item.name} className="max-h-12 w-auto opacity-70 hover:opacity-100 transition-opacity" />
              ) : (
                <span className="text-gray-300 font-semibold tracking-wide">{item.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}